import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { ChevronRight, CloudUpload, Shapes, Users } from "lucide-react";
import { RavenIcon } from "@ravenappdev/raven-ui";
import { useNavigate } from "react-router-dom";

interface AdminTile {
  to: string;
  title: string;
  description: string;
  icon: JSX.Element;
}

const TILES: AdminTile[] = [
  {
    to: "/suggestions/admin/categories",
    title: "Categories",
    description:
      "Add, rename, reorder, or deactivate the suggestion categories employees pick from.",
    icon: (
      <RavenIcon
        icon={Shapes}
        fontSize="large"
        strokeWidth={2}
        color="primary"
      />
    ),
  },
  {
    to: "/suggestions/admin/custodians",
    title: "Custodian recipients",
    description:
      "Configure HR and Corporate recipients notified when new suggestions arrive.",
    icon: (
      <RavenIcon
        icon={Users}
        fontSize="large"
        strokeWidth={2}
        color="primary"
      />
    ),
  },
  {
    to: "/suggestions/admin/import",
    title: "Historical import",
    description:
      "One-time upload of pre-existing 2026 suggestions from the Excel template.",
    icon: (
      <RavenIcon
        icon={CloudUpload}
        fontSize="large"
        strokeWidth={2}
        color="primary"
      />
    ),
  },
];

export default function Admin() {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h4" mb={0.5}>
        Admin
      </Typography>
      <Typography color="text.secondary" mb={3}>
        Manage ESS configuration. These settings affect every user.
      </Typography>

      <Grid container spacing={2}>
        {TILES.map((t) => (
          <Grid key={t.to} size={{ xs: 12, md: 4 }}>
            <Card sx={{ height: "100%" }}>
              <CardActionArea
                onClick={() => navigate(t.to)}
                sx={{ height: "100%" }}
              >
                <CardContent>
                  <Stack
                    direction="row"
                    alignItems="flex-start"
                    spacing={2}
                  >
                    <Box>{t.icon}</Box>
                    <Box sx={{ flex: 1 }}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography variant="h6">{t.title}</Typography>
                        <RavenIcon
                          icon={ChevronRight}
                          fontSize="medium"
                          color="action"
                        />
                      </Stack>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        mt={0.5}
                      >
                        {t.description}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
